export default {
    env: 'production',
    buildNumber: 'prod-1843',
    bugsnagApi: '838b7fa2b2e35729041cdcb9d032cdf8',
};
